import { set_dto_selected_merchant_or_product } from "../../../../classes/dto-setters/dto-setter";
import { GET_SELECTED_MERCHANT_OR_PRODCUCT } from "../../../../database/get-stored-data";
import { dto_selected_merchant_or_product } from "../../../../classes/dto-selected-merchant-or-product";
import { dto_MobileAppCategory } from "../../../../classes/dto-mobile-app-category";
import { PT_PRODUCT_LIST } from "../../../../routes/stack/paths/pt-home";
import { dto_Merchant } from "../../../../classes/dto-merchant";
import { Carousel } from "react-responsive-carousel";
import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";

export default class SectionSliderImage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dataBanner: [],
      isSplit: false,
    };
  }

  componentDidMount() {
    let array = this.props.pmData;
    let structuredArray = [];

    for (let i = 0; i < array.length; i++) {
      let parts = array[i].split("λ");
      let temp = [];
      let isAnySplittable = false;

      for (let j = 0; j < parts.length; j++) {
        let itemParts = parts[j].split("|");

        if (itemParts.length === 4) {
          temp.push({
            bannerUrl: itemParts[0],
            CATID: itemParts[1],
            ListType: itemParts[2],
            MID: itemParts[3],
            isSplit: true,
          });
          isAnySplittable = true;
        }
      }

      if (isAnySplittable) {
        // Only add the valid split items
        structuredArray.push(...temp);
      } else {
        // Not splittable → push original element once
        structuredArray.push({
          bannerUrl: array[i],
          CATID: "0",
          ListType: "",
          MID: "",
          isSplit: false,
        });
      }
    }

    this.setState({
      dataBanner: structuredArray,
    });
  }

  render() {
    return (
      <div
        style={{ margin: 10 }}
        className="fadeInUp animated"
        data-wow-duration="300ms"
        data-wow-delay="0ms"
      >
        <Carousel
          dynamicHeight={180}
          showThumbs={false}
          autoPlay={true}
          infiniteLoop={true}
          showArrows={true}
          swipeable={false}
          emulateTouch={false}
        >

          {this.state.dataBanner.map((item) => {
            return (
              <div
                key={item.MID || item.bannerUrl} 
                 onClick={async (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (item.isSplit === true && item.CATID !== '0') {
                    let rs = await GET_SELECTED_MERCHANT_OR_PRODCUCT();
                    if (rs) {
                      rs.CATID = item.CATID;
                      await set_dto_selected_merchant_or_product(rs);
                    }
                    dto_selected_merchant_or_product.MobileAppUIType = 2;
                    dto_MobileAppCategory.MACID = 1;
                    dto_Merchant.MID = item.MID;
                    dto_selected_merchant_or_product.CATID = item.CATID;
                    dto_MobileAppCategory.ListType = item.ListType;
                    this.props.navigate(
                      PT_PRODUCT_LIST.replace(":navPage", "shome").replace(
                        ":isSec",
                        "false"
                      )
                    );
                  } 
                }}
              >
                <img src={item.bannerUrl} alt="" style={{ height: 180 }} />
                <div>{item.isSplit ? "Split Banner" : "Normal Banner"}</div>
                <div>{item.bannerUrl}</div>
              </div>
            );
          })}
        </Carousel>
      </div>
    );
  }
}
